import { useSelector, useDispatch } from 'react-redux';
import { fetchWalletBalance, updateWalletAfterSpin } from '../store/walletSlice';

/**
 * Хук для работы с данными кошелька из Redux store
 * Используйте useWalletConnection() из contexts/WalletContext для WebSocket соединения
 */
export const useWalletRedux = () => {
  const dispatch = useDispatch();
  const wallet = useSelector((state) => state.wallet);
  
  const refreshBalance = () => {
    console.log("refreshBalance")
    dispatch(fetchWalletBalance());
  };
  
  const updateAfterSpin = (spinResult) => {
    dispatch(updateWalletAfterSpin(spinResult));
  };
  
  return {
    ...wallet,
    refreshBalance,
    updateAfterSpin,
  };
};
